import LocalStorage from 'yoda-core-components/lib/helpers/LocalStorage/LocalStorage';
import User from '../User/User';

export const MY_ALERTS_EMAIL = 'MY_ALERTS_EMAIL';
export const DP_USER_EMAIL = 'DP_USER_EMAIL';

export const getMyALertsEmailId = () => {
    const myAlertEmail = LocalStorage.getData(MY_ALERTS_EMAIL);
    const userEmail = LocalStorage.getData(DP_USER_EMAIL);
    if (myAlertEmail && myAlertEmail === userEmail) {
        return myAlertEmail;
    }
    const isUserLoggedIn = User.isUserLoggedIn(true);
    /* istanbul ignore next */
    if (isUserLoggedIn && userEmail) {
        LocalStorage.setData(MY_ALERTS_EMAIL, userEmail);
        return LocalStorage.getData(MY_ALERTS_EMAIL);
    }
    if (!isUserLoggedIn && myAlertEmail) {
        return myAlertEmail;
    }
    return '';
};
